
import {APPLIED_JOB_REQUEST_REQUEST, APPLIED_JOB_REQUEST_SUCCESS,APPLIED_JOB_REQUEST_FAIL} from "../constants/AuthConstant";

const axios = require("axios");
export const AppliedJobsAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: APPLIED_JOB_REQUEST_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_apply_job_list_by_candidateId?candidateId=${data?.candidateId}&pageNumber=${data.pageNumber}&pageSize=10`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: APPLIED_JOB_REQUEST_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };
  export const loadAllDetailsPre = (data) => {
    return {
      type: APPLIED_JOB_REQUEST_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };
  